import { StrategyDetailsPageGetDocumentRecordQuery, StrategyDetailsPageListDocumentRecordsQuery } from '@/__generated__/graphql';
import { differenceInDays } from 'date-fns';
import { DocumentRecordSentimentFlag } from './types';

export const isMoreThan90DaysInPast = (date: Date | string): boolean => {
  const currentDate = new Date();
  const inputDate = new Date(date);
  const difference = differenceInDays(currentDate, inputDate);
  return difference > 90;
};

export const getTagStyleType = (sentimentFlag: DocumentRecordSentimentFlag) => {
  const tagStyleMap: Record<DocumentRecordSentimentFlag, 'valid' | 'warning' | 'default'> = {
    Positive: 'valid',
    Negative: 'warning',
    Neutral: 'default'
  };

  return tagStyleMap[sentimentFlag] || 'default';
};

export const getManagerUpdateName = (
  fields:
    | StrategyDetailsPageGetDocumentRecordQuery['getDocumentRecord']['fields']
    | StrategyDetailsPageListDocumentRecordsQuery['listDocumentRecords']['records'][number]['documentRecordFieldAnswers'],
  name: string
) => {
  const basicInfoNameField = fields?.find((field) => field.documentField.name === 'Document Record Name');

  if (basicInfoNameField && basicInfoNameField.value === null && basicInfoNameField.AI?.answers?.length) {
    return basicInfoNameField.AI.answers[0];
  }
  return name;
};
